import React,{Fragment} from 'react';
import './index.scss';
import DataGrid from 'devextreme-react/data-grid';

export default function EndOfDay(){
return(
    
 <Fragment>
 <h4 className={'content-block'}>End Of Day</h4>
 <div className={'content-block'}>
     <DataGrid></DataGrid>
 </div>
</Fragment>
)};